import { Menu } from '@react-admin/ra-rbac';
import React from 'react';

import './styles.scss';

const CustomMenu = ({ ...props }) => (
  <Menu {...props} className="custom-menu" />
);
export default CustomMenu;
